<template lang="pug">
.container-fluid
	nav(aria-label="breadcrumb", style="position:absolute;display:block;top: 0px;left: 0;right: 0;padding: 10px;")
		.row
			.col
				ol.breadcrumb(style="background-color:transparent !important;")
					li.breadcrumb-item
						router-link(to="/main/galerias")
							span.fa.fa-home.mr-2
							| Galerias
					li.breadcrumb-item(v-if="galeria")
						| {{galeria.Nombre}}
						span(style="color:#777777;")  {{galeria.FechaGaleriaUnix | moment('DD-MMM-YYYY')}}
					li.breadcrumb-item(v-if="!galeria && $route.name === 'buscador'")
						a(href="#") Buscador
			.col(style="max-width:300px;")
				.input-group
					//input-query.form-control(input-class="form-control", :conservar="true", :realtime="true", url="galerias/php/api/query-personas.php?buscar=1", placeholder="Búsqueda rápida", v-model="cadena", @selected="seleccionaNombre($event)")
					input.form-control(placeholder="Buscar cadena", @keypress.enter="doSearch", v-model="cadena")
					.input-group-append
						button.btn.btn-primary
							span.fa.fa-search
	router-view(style="position:absolute;display:block;top: 50px;left: 0;right: 0;padding: 10px; bottom: 0;overflow:auto;")
	modal-buscador(v-if="buscar", @cerrar="buscar = false")
	gestion-etiquetas(v-if="gestionEtiquetas", @cerrar="gestionEtiquetas = false")
</template>

<script>
import VisorGaleria from './componentes/visor-galerias/visor-galeria'
import ModalBuscador from './componentes/buscador/modal-buscador.vue'
import GestionEtiquetas from './componentes/gestion-etiquetas/gestion-etiquetas.vue'
import { mapGetters } from 'vuex'
export default {
	components: {
		'visor-galeria': VisorGaleria,
		'modal-buscador': ModalBuscador,
		'gestion-etiquetas': GestionEtiquetas
	},
	created () {
		// Seteamos el menú superior
		const menu = [
			{
				id: 'buscador',
				nombre: 'Buscador',
				icono: 'fa fa-search',
				callback: (e) => {
					this.buscar = true
				}
			}
		]

		if (this.permisos.galerias_editarTodos) {
			menu.push(
				{
					id: 'gestorEtiquetas',
					nombre: 'Etiquetas',
					icono: 'fa fa-tag',
					callback: (e) => {
						this.gestionEtiquetas = true
					}
				}
			)
		}

		this.$store.commit('top/setMenu', menu)
	},
	data () {
		return {
			buscar: false,
			gestionEtiquetas: false,
			cadena: ''
		}
	},
	computed: {
		...mapGetters({
			galeria: 'galerias/galeria',
			permisos: 'permisos/permisos'
		})
	},
	methods: {
		seleccionaNombre (ev) {
			this.cadena = ev.data.Nombre + ' ' + ev.data.Apellidos
			this.doSearch()
		},
		doSearch () {
			this.$store.dispatch('galerias/buscar', {cadena: this.cadena})
			this.$router.push('/main/galerias/buscador')
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/galerias/vue/galerias.vue